import type { ReactNode } from "react";

import { StyledSignalCount, StyledSignalListTypeItemContainer } from "./styles";

interface ISignalsListTypeItemWrapperProps {
    className?: string;
    count: number;
    onClick?: VoidFunction;
    dataAutomation?: string;
    children: ReactNode;
}

export const SignalsListTypeItemWrapper = ({
    className,
    count,
    onClick,
    dataAutomation,
    children,
}: ISignalsListTypeItemWrapperProps) => {
    return (
        <StyledSignalListTypeItemContainer
            className={className}
            onClick={onClick}
            data-automation={dataAutomation}
            $clickable={!!onClick}
        >
            {children}
            <StyledSignalCount>{count}</StyledSignalCount>
        </StyledSignalListTypeItemContainer>
    );
};
